import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const NewsIconSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_127_125)">
            <path
                d="M35.0833 10H18.75C17.1423 10 15.8333 11.309 15.8333 12.9167V18.1667H10V34.5C10 36.4297 11.5703 38 13.5 38H34.5C36.4297 38 38 36.4297 38 34.5V12.9167C38 11.309 36.691 10 35.0833 10ZM15.8333 34.5C15.8333 35.7868 14.7868 36.8333 13.5 36.8333C12.2132 36.8333 11.1667 35.7868 11.1667 34.5V19.3333H15.8333V34.5ZM36.8333 34.5C36.8333 35.7868 35.7868 36.8333 34.5 36.8333H16.1063C16.6617 36.2138 17 35.396 17 34.5V12.9167C17 11.9518 17.7852 11.1667 18.75 11.1667H35.0833C36.0482 11.1667 36.8333 11.9518 36.8333 12.9167V34.5ZM27.5 18.1667H34.5V19.3333H27.5V18.1667ZM19.3333 22.8333H34.5V24H19.3333V22.8333ZM19.3333 27.5H34.5V28.6667H19.3333V27.5ZM19.3333 32.1667H34.5V33.3333H19.3333V32.1667ZM25.1667 13.5H19.3333V19.3333H25.1667V13.5ZM24 18.1667H20.5V14.6667H24V18.1667Z"
                fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clip0_127_125">
                <rect width="28" height="28" fill="currentColor" transform="translate(10 10)" />
            </clipPath>
        </defs>
    </svg>
)
const NewsIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} style={{ fontSize: '40px' }}>
        {NewsIconSvg}
    </SvgIcon>
)
export default NewsIcon
